
import FontCommand from '@ckeditor/ckeditor5-font/src/fontcommand';

export default class BackgroundColorCommand extends FontCommand {

	constructor( editor ) {
		super( editor, 'backgroundColor' );
	}
}
